<div class="bg-light min-vh-100 d-flex flex-row align-items-center">
  <c-container>
    <c-row class="justify-content-center">
      <c-col md="6">
        <c-card-group>
          <c-card class="p-4">
            <c-card-body>
              <form cForm [formGroup]="form" (submit)="onSubmit()">
                <div class="row">
                  <div class="col-7">
                    <h1>Entrar</h1>
                    <p class="text-muted">Acesse sua conta</p>
                  </div>
                  <div class="col-5" style="text-align-last: end;">
                    <img src="assets/img/brand/logo-ladder.png" style="height: 70px" alt="Logo" />
                  </div>
                </div>
                <c-input-group class="mb-3">
                  <span cInputGroupText>
                    <svg cIcon name="cilUser"></svg>
                  </span>
                  <input autoComplete="username" cFormControl placeholder="Usuário" formControlName="username"
                    required />
                </c-input-group>
                <c-input-group class="mb-4">
                  <span cInputGroupText>
                    <svg cIcon name="cilLockLocked"></svg>
                  </span>
                  <input autoComplete="current-password" cFormControl placeholder="Senha"
                    [type]="showPwd ? 'text' : 'password'"
                    formControlName="password" required/>
                  <span class="click" cInputGroupText (click)="showPwd = !showPwd">
                    <svg cIcon name="cilLowVision"></svg>
                  </span>
                </c-input-group>

                <div class="alert alert-danger mb-3" *ngIf="!!error">
                  {{ error }}
                </div>

                <c-row>
                  <c-col xs="6">
                    <button cButton class="px-4" color="primary" type="submit"
                      [disabled]="form.invalid || loading">
                      <span *ngIf="loading; else entrarText">
                        <span class="spinner-border spinner-border-sm me-1"></span>
                        Entrando...
                      </span>
                      <ng-template #entrarText>Entrar</ng-template>
                    </button>
                  </c-col>
                  <c-col class="text-right" xs="6" style="text-align-last: end;">
                    <button cButton class="px-0" color="link" (click)="forgotPassword()">
                      Esqueceu a senha?
                    </button>
                    <ng-container *ngIf="supportReady$ | async">
                      <br *ngIf="(supportType$ | async) !== 'none'">
                      <!-- Chatwoot disponível -->
                      <button *ngIf="(supportType$ | async) === 'chatwoot'"
                        cButton class="px-0" color="link" type="button" (click)="openSupport()"
                        [disabled]="supportLoading$ | async">
                        <span *ngIf="supportLoading$ | async; else helpTextChatwoot">
                          <span class="spinner-border spinner-border-sm me-1"></span>
                          Carregando...
                        </span>
                        <ng-template #helpTextChatwoot>Precisa de ajuda?</ng-template>
                      </button>
                      <!-- Apenas contato da revenda -->
                      <button *ngIf="(supportType$ | async) === 'contact'"
                        cButton class="px-0" color="link" type="button" (click)="openContactModal()">
                        Precisa de ajuda?
                      </button>
                    </ng-container>
                  </c-col>
                </c-row>
              </form>
            </c-card-body>
          </c-card>
          <!-- <c-card [ngStyle]="{'width.%': 44}" class="text-white bg-primary py-5">
            <c-card-body class="text-center">
              <div>
                <h2>Não tem acesso?</h2>
                <p>
                  Entre em contato com a revenda de sua região e solicite uma demonstração.
                </p>
                <button [active]="true" cButton class="mt-3" color="primary" routerLink="/register">
                  Entre em contato!
                </button>
              </div>
            </c-card-body>
          </c-card> -->
        </c-card-group>
      </c-col>
    </c-row>
  </c-container>
</div>

<!-- Modal de contato da revenda -->
<c-modal [visible]="contactModalVisible" (visibleChange)="contactModalVisible = $event" alignment="center">
  <c-modal-header>
    <h5 cModalTitle>Contato - {{ supportService.preLoginResellerName }}</h5>
    <button cButtonClose (click)="contactModalVisible = false"></button>
  </c-modal-header>
  <c-modal-body>
    <div class="mb-2" *ngIf="supportService.preLoginContact?.tel_phone">
      <svg cIcon name="cilPhone" size="sm" class="me-1"></svg>
      <strong>Tel. Fixo:</strong>
      <a [href]="'tel:' + supportService.preLoginContact.tel_phone" class="ms-2">
        {{ supportService.preLoginContact.tel_phone }}
      </a>
    </div>
    <div class="mb-2" *ngIf="supportService.preLoginContact?.cel_phone">
      <svg cIcon name="cilMobile" size="sm" class="me-1"></svg>
      <strong>Celular:</strong>
      <a [href]="'tel:' + supportService.preLoginContact.cel_phone" class="ms-2">
        {{ supportService.preLoginContact.cel_phone }}
      </a>
    </div>
    <div class="mb-2" *ngIf="supportService.preLoginContact?.email">
      <svg cIcon name="cilEnvelopeClosed" size="sm" class="me-1"></svg>
      <strong>E-mail:</strong>
      <a [href]="'mailto:' + supportService.preLoginContact.email" class="ms-2">
        {{ supportService.preLoginContact.email }}
      </a>
    </div>
    <div class="mb-2" *ngIf="supportService.preLoginContact?.website">
      <svg cIcon name="cilGlobeAlt" size="sm" class="me-1"></svg>
      <strong>Website:</strong>
      <a [href]="supportService.preLoginContact.website" target="_blank" rel="noopener" class="ms-2">
        {{ supportService.preLoginContact.website }}
      </a>
    </div>
  </c-modal-body>
  <c-modal-footer>
    <button cButton color="secondary" (click)="contactModalVisible = false">Fechar</button>
  </c-modal-footer>
</c-modal>
